import { get, put } from '@/helpers/http';

export function getCompanyAnalytics() {
  return get('/company/analytics');
}

export function getCurrentCompany(companyId) {
  return get(`/companies/${companyId}`);
}

export function updateCompany(company) {
  return put(`/companies/${company.id}`, company);
}
